import { FC } from 'react';
import { Perform, MAX_MULTISHOW } from './perform';
import { ReferenceDto } from '@servicetitan/application-data/marketing';
import { ValuePopover } from './value-popover';

interface PerformRefdtoMultiSelectProps {
    name: string;
    value?: ReferenceDto[] | undefined;
}

export const PerformRefdtoMultiSelect: FC<PerformRefdtoMultiSelectProps> = ({
    value,
    name,
}: PerformRefdtoMultiSelectProps) => {
    const convertToString = (value: ReferenceDto[]) =>
        value.map(item => item.name || item.id).join(', ');

    const convertToArray = (value: ReferenceDto[]) =>
        value.map(item => (item.name || item.id) + '');

    if (value && value.length > MAX_MULTISHOW) {
        return (
            <Perform
                name={name}
                text={
                    <ValuePopover
                        value={convertToArray(value)}
                        title={name}
                        trigger={`${value.length} selected`}
                    />
                }
            />
        );
    }

    if (value && value.length <= MAX_MULTISHOW) {
        return <Perform name={name} text={convertToString(value)} />;
    }

    return <Perform name={name} text="" />;
};
